import { useState, useCallback } from 'react';
import { toast } from 'sonner';

const INITIAL_FORM = Object.freeze({
  name: '',
  email: '',
  phone: '',
  company: '',
  service: 'Virtual Assistants',
  message: '',
});

const validateForm = (form) => Boolean(form.name && form.email && form.message);

const buildSuccessMessage = (form) =>
  `Thanks ${form.name.split(' ')[0]}! We'll get back to you within 24 hours.`;

export const useContactForm = () => {
  const [form, setForm] = useState(INITIAL_FORM);

  const update = useCallback((key) => (e) => {
    const { value } = e.target;
    setForm((prev) => ({ ...prev, [key]: value }));
  }, [setForm]);

  const submit = useCallback((e) => {
    e.preventDefault();
    if (!validateForm(form)) {
      toast.error('Please fill in name, email and message.');
      return;
    }
    toast.success(buildSuccessMessage(form));
    setForm(INITIAL_FORM);
  }, [form, setForm]);

  return { form, update, submit };
};
